import{INDEX_TOKEN}from"./indices.js";
import{OTHER_OBJECT_TOKEN_TYPES,OTHER_STRING_TOKEN_TYPES}from"./other.js";
import{PROP_TOKEN}from"./prop.js";


export const getTokenType=(token)=>{
const tokenType=getObjectTokenType(token);
return tokenType===undefined?UNKNOWN_TYPE:tokenType.name
};

const UNKNOWN_TYPE="unknown";


export const getObjectTokenType=(token)=>
OBJECT_TOKEN_TYPES.find((tokenType)=>tokenType.testObject(token));


export const getStringTokenType=(chars,isProp)=>
isProp?
PROP_TOKEN:
STRING_TOKEN_TYPES.find((tokenType)=>tokenType.testString(chars));



const STRING_TOKEN_TYPES=[...OTHER_STRING_TOKEN_TYPES,PROP_TOKEN];
const OBJECT_TOKEN_TYPES=[PROP_TOKEN,...OTHER_OBJECT_TOKEN_TYPES];


export const isPathToken=(token)=>
PROP_TOKEN.testObject(token)||
INDEX_TOKEN.testObject(token)&&token>=0&&!Object.is(token,-0);